import { useMemo } from 'react'
import { get, useFormContext } from 'react-hook-form'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import HFDropdown from 'components/HFInputs/HFDropdown'

import styles from './RuleEntryOutput.module.sass'

const icon = (
	<svg className={styles['icon']} width='16' height='16' viewBox='0 0 16 16'>
		<path d='M8.00001 10C9.10458 10 10 9.10458 10 8.00001C10 6.89544 9.10458 6.00001 8.00001 6.00001C6.89544 6.00001 6.00001 6.89544 6.00001 8.00001C6.00001 9.10458 6.89544 10 8.00001 10Z' />
		<path d='M8.66668 2.71268V1.33334H7.33334V2.71268C6.16012 2.86225 5.06978 3.39717 4.23347 4.23347C3.39717 5.06978 2.86225 6.16012 2.71268 7.33334H1.33334V8.66668H2.71268C2.86214 9.83994 3.39702 10.9303 4.23335 11.7667C5.06968 12.603 6.16008 13.1379 7.33334 13.2873V14.6667H8.66668V13.2873C9.83994 13.1379 10.9303 12.603 11.7667 11.7667C12.603 10.9303 13.1379 9.83994 13.2873 8.66668H14.6667V7.33334H13.2873C13.1378 6.16012 12.6029 5.06978 11.7665 4.23347C10.9302 3.39717 9.8399 2.86225 8.66668 2.71268ZM8.00001 12C5.79401 12 4.00001 10.206 4.00001 8.00001C4.00001 5.79401 5.79401 4.00001 8.00001 4.00001C10.206 4.00001 12 5.79401 12 8.00001C12 10.206 10.206 12 8.00001 12Z' />
	</svg>
)

const outputInputColors = [
	styles.accentContrastColor,
	styles.accentContrastColor,
	'transparent',
	'transparent',
].join(';')

const PriorityRuleEntryOutput = ({ path }) => {
	const { formState } = useFormContext()
	const { i18n } = useGlobal()

	const priorityOptions = [
		{
			value: 1,
			text: i18n`Very High`,
		},
		{
			value: 2,
			text: i18n`High`,
		},
		{
			value: 3,
			text: i18n`Medium`,
		},
		{
			value: 4,
			text: i18n`Low`,
		},
		{
			value: 5,
			text: i18n`Very Low`,
		},
	]

	const errors = get(formState.errors ?? {}, path)
	const error = useMemo(() => {
		return errors?.output?.type?.message ?? errors?.output?.output?.message
	}, [errors])

	return (
		<span className={[styles['rule-output']]} data-error={error}>
			<VStack justify='space-around'>
				<HStack align='center' gap='xsmall' justify='space-between'>
					<HStack align='center'>
						{icon}
						<small className={styles['priority-label']}>
							<strong>{i18n`Priority`}</strong>
						</small>
					</HStack>
				</HStack>
				<HFDropdown
					className={styles['selector']}
					tint={outputInputColors}
					name={`${path}.output.priority`}
					options={priorityOptions}
					optionsAlign='right'
				/>
			</VStack>
		</span>
	)
}

export default PriorityRuleEntryOutput
